<template>
  <div :style="maxHeight" style="overflow-y: auto;overflow-x: hidden">
    <el-row style="height: 50%;">
      <el-col :span="12" style="border-right: 8px solid whitesmoke;border-bottom: 8px solid whitesmoke;height: 100%">
        <div class="title">
          <span>{{ '日不良重量' }}</span>
          <div class="space-between">
            <el-date-picker v-model="fromData.dateDay" @change="getProcessDayBad" :clearable="false" format="YYYY 年 M 月" value-format="YYYY-M-1" type="month" placeholder="选择月份" style="width: 110px" size="small"/>
          </div>
        </div>
        <div class="chart_size" v-loading="dayBadLoading" element-loading-text="数据加载中" id="processDayBad"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "CutOffProcessAccumulateBad",
  components: {},
  data() {
    return {
      maxHeight:'',
      fromData:{
        dateDay: this.getDateFormat(),
      },
      countDayList:[],
      processDayBad: {
        title: [
          {
            text: '',
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
        },
        grid: {
          left: '6%',
          right: '5%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '不良重量(kg)',
            min:0,
            axisLabel: {
              formatter: function (value){
                return value.toFixed(2)
              }
            }
          },
          {
            type: 'value',
            name: '累计不良率(%)',
            min:0,
            axisLabel: {
              formatter: function (value){
                return value.toFixed(2) + '%'
              }
            }
          }
        ],
        series: [
          {
            name: '不良重量',
            type: 'bar',
            yAxisIndex:0,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '累计不良率',
            type: 'line',
            yAxisIndex: 1,
            // label: {
            //   show: true,
            //   position: 'top',
            //   formatter: (params) => params.value > 0 ? params.value : '',
            //   fontSize:'10'
            // },
            tooltip: {
              valueFormatter: function (value) {
                return value + ' %';
              }
            },
            data: []
          },
          {
            name: '目标不良率',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + ' %';
              }
            },
            data: []
          },
        ]
      },
      dayBadLoading: false,
    }
  },methods: {
    getMaxHeight() {
      let pageHeight = document.body.scrollHeight - 160;
      this.maxHeight = "height: "+pageHeight+"px;";
    },
    getDateFormat(){
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-1"
    },
    renderEcharts(id,option) {
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)
      }
    },
    async getProcessDayBad() {
      if (!this.fromData.dateDay){
        this.fromData.dateDay = this.getDateFormat()
      }
      this.fromData.countDayList = this.countDayList;
      this.dayBadLoading = true
      let {data: res} = await this.$axios.post('mfg/processProduce/getProcessDayBad',this.fromData);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }

      this.processDayBad.xAxis[0].data = this.countDayList
      this.processDayBad.series[0].data = res.data.processDayBadWeightList
      this.processDayBad.series[1].data = res.data.processDayRateList
      this.processDayBad.series[2].data = res.data.productivityList

      let a = this.$common.getDivisor(Math.max(...res.data.processDayBadWeightList))
      this.processDayBad.yAxis[0].max = Math.ceil(Math.max(...res.data.processDayBadWeightList)/a)*a
      this.processDayBad.yAxis[0].interval = Math.round(this.processDayBad.yAxis[0].max/5*100)/100

      let b = 0
      for (let item of res.data.processDayRateList) {
        if (b < item) {
          b = item;
        }
      }

      if (Math.round(b) > 0) {
        b = Math.round(b)
      }

      if (b <= 0.1) {
        b = 0.1
      }

      if (b > 0.1 && b < 0.5) {
        b = b + 0.1
      }

      // this.processDayBad.yAxis[0].max = a
      // this.processDayBad.yAxis[0].interval = a / 5
      this.processDayBad.yAxis[1].max = b
      this.processDayBad.yAxis[1].interval = b / 5
      this.renderEcharts('processDayBad',this.processDayBad)
      this.dayBadLoading = false
    },
    getCountDays(month) {
      const d = new Date(month)
      const y = d.getFullYear()
      //获取本月的下一个月
      const m = d.getMonth() + 1
      // 下一个月的第0天就是这个月的天数
      this.countDays = new Date(y, m, 0).getDate();
      for (let i = 1; i <= this.countDays; i++) {
        //准备天数集合
        this.countDayList.push(i)
      }
    },
  },created() {
    this.getMaxHeight()
    var currentDate = new Date();
    //currentDate.setDate(currentDate.getDate() - 1);
    this.getCountDays(currentDate);
    this.getProcessDayBad()
  }
}
</script>

<style scoped>

.title{
  border-left: 3px solid steelblue;
  height: 25px;
  width: 80%;
  font-size: 16px;
  margin-left: 40px;
}
.chart_size{
  width: 100%;
  height: 95%
}
</style>